import { render } from "./App.vue?vue&type=template&id=578be236&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/main.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=578be236&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578be236"]])

export default __exports__